import { Component, effect, EffectRef, ElementRef, inject, Signal, ViewChild } from '@angular/core';
import { ButtonComponent } from '@components/shared/button/button.component';
import { ButtonType } from '@models/enums/components/Button/ButtonType.enum';
import { AppViews } from '@models/enums/dvm/DvmViews.enum';
import { MobileButtonService } from '@services/components/mobile-button.service';
import { DvmService } from '@services/dvm.service';
import anime from 'animejs';

@Component({
  selector: 'app-mobile-button',
  standalone: true,
  imports: [
    ButtonComponent
  ],
  templateUrl: './mobile-button.component.html',
  styleUrl: './mobile-button.component.css'
})
export class MobileButtonComponent {

  // VIEW CHILDREN
  @ViewChild('mobileBtn', { read: ElementRef })
  private readonly mobileBtn!:  ElementRef<ButtonComponent>;

  // SERVICES
  private readonly view:        Signal<AppViews| null> = inject(DvmService).view;
  public  readonly service:     MobileButtonService    = inject(MobileButtonService);

  // STATE
  public          showElement:  boolean     = this.view() === AppViews.Topview || this.view() === AppViews.Main;
  public          isActive:     boolean     = false;
  public readonly buttonType:   ButtonType  = ButtonType.Pill;

  // EFFECT
  public readonly toggleVisibility: EffectRef = effect((): void=> {

    const view: AppViews | null = this.view(),
          show: boolean = view === AppViews.Topview || view === AppViews.Main;

    if(view === null) return;

    if(this.showElement) this.animateButton(show);    
    else setTimeout((): void => this.animateButton(show), 300);
  
  })

  private animateButton(show: boolean): void {
    
    anime({
      begin:    (): void => { if(show && !this.showElement) this.showElement = true },
      complete: (): void => { 
        if(!show && this.showElement) this.showElement = false;
        if(!this.showElement && this.service.active()) this.service.toggleButton();
      },
      targets:  this.mobileBtn.nativeElement,
      opacity:  show ? 1 : 0,
      duration: 300,
      easing:   'easeInOutQuad',
    })

  }

}
